import { Base64 } from "js-base64";
import { saveAs } from "file-saver";

export const userExportBlob = (
  rawFileData,
  fileName = "User.xlsx",
  mimeType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
) => {
  try {
    if (!rawFileData || typeof rawFileData !== "string") {
      // throw new Error("Invalid base64 data");
      throw new Error("Something Went Wrong!");
    }

    const byteArray = Base64.toUint8Array(rawFileData);
    const blob = new Blob([byteArray], { type: mimeType });
    saveAs(blob, fileName);
  } catch (err) {
    console.error("Error in userExportBlob:", err.message);
    return err;
  }
};
